import { Component, OnInit } from '@angular/core';
import {MatTabsModule} from '@angular/material/tabs';

@Component({
  selector: 'app-asc',
  templateUrl: './asc.component.html',
  styleUrls: ['./asc.component.css']
})
export class AscComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
